import { BillOfMaterialRecord } from '../../../../../types/BillOfMaterial';
import React from 'react';
import { Descriptions } from 'antd';
import StatusTag from '../../../../../components/ui/StatusTag';

interface BillOfMaterialInfoViewProps {
  data?: BillOfMaterialRecord;
}

const BillOfMaterialInfoView: React.FC<BillOfMaterialInfoViewProps> = ({
  data,
}) => {
  return (
    <>
      <Descriptions title="Bill of Material">
        <Descriptions.Item label="BOM No">{data?.code}</Descriptions.Item>
        <Descriptions.Item label="PRODER no">
          {data?.proderno}
        </Descriptions.Item>
        <Descriptions.Item label="PO no">{data?.pono}</Descriptions.Item>
        <Descriptions.Item label="Required Date">
          {data?.requiredDate}
        </Descriptions.Item>
        <Descriptions.Item label="Date Entry">
          {data?.dateEntry}
        </Descriptions.Item>
        <Descriptions.Item label="Shipment Date">
          {data?.dateshipment}
        </Descriptions.Item>
        <Descriptions.Item label="Revision">{data?.revision}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag status={data?.status ?? ''} />
        </Descriptions.Item>
        <Descriptions.Item label="Remarks">{data?.remarks}</Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default BillOfMaterialInfoView;
